import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { Cita } from '../../types';
import { obtenerCitasDelDia, obtenerDiasDelMes } from '../../lib/fechas';

interface Props {
  mes: Date;
  citas: Cita[];
  onCambiarMes: (direccion: number) => void;
}

const DIAS_SEMANA = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

export function CalendarioMensual({ mes, citas, onCambiarMes }: Props) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => onCambiarMes(-1)}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ChevronLeft size={24} />
        </button>
        <h2 className="text-2xl font-bold text-gray-800">
          {mes.toLocaleDateString('es-MX', { month: 'long', year: 'numeric' })}
        </h2>
        <button
          onClick={() => onCambiarMes(1)}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      <div className="grid grid-cols-7 gap-2">
        {DIAS_SEMANA.map((dia) => (
          <div key={dia} className="text-center font-semibold text-gray-600 py-2">
            {dia}
          </div>
        ))}

        {obtenerDiasDelMes(mes).map((dia, idx) => {
          const citasDelDia = obtenerCitasDelDia(citas, dia.fecha);
          const esHoy = dia.fecha.toDateString() === new Date().toDateString();

          return (
            <div
              key={idx}
              className={`
                min-h-24 p-2 border rounded-lg transition-all
                ${dia.esOtroMes ? 'bg-gray-50 text-gray-400' : 'bg-white'}
                ${esHoy ? 'border-indigo-500 border-2' : 'border-gray-200'}
                ${citasDelDia.length > 0 ? 'hover:shadow-md cursor-pointer' : ''}
              `}
            >
              <div className="text-sm font-medium mb-1">{dia.fecha.getDate()}</div>
              {citasDelDia.length > 0 && (
                <div className="space-y-1">
                  {citasDelDia.map((cita) => (
                    <div
                      key={cita.id}
                      className="text-xs bg-indigo-100 text-indigo-800 rounded px-2 py-1 truncate"
                      title={`${cita.hora} - ${cita.cliente}`}
                    >
                      {cita.hora} {cita.cliente}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
